// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eruda-dev-tools .eruda-tools .eruda-geolocation{position:relative}.eruda-dev-tools .eruda-tools .eruda-geolocation .eruda-map{position:absolute;left:0;top:0;width:100%;height:100%}.eruda-dev-tools .eruda-tools .eruda-geolocation .eruda-info{position:absolute;bottom:0;left:0;background:var(--darker-background);padding:10px;color:var(--foreground);width:100%;border-top:1px solid var(--border);z-index:1000}", ""]);
// Exports
module.exports = exports;
